import React from "react";
import { useState, useCallback, useLayoutEffect } from "react";
import { SimpleGrid } from '@chakra-ui/layout';

import { VStack, Heading } from "@chakra-ui/react";
import { useContractKit } from "@celo-tools/use-contractkit";

import Layout from "../components/layout";
import NFTCard from "../components/nft-card";

import { getMetadata } from "../lib/utils";

import { tokenURI, currentTokenIds } from "../lib/NFT";

function NFT() {
  const [tokens, setTokens] = useState([]);

  const { kit } = useContractKit();

  const loadAllTokens = useCallback(async () => {
    /*
      1. Find current tokenID
      2. Fetch all tokens upto the tokenID
    */
    let nfts = [];
    const current = await currentTokenIds(kit);
    for (let i = 1; i < parseInt(current) + 1; i++) {
      const metadata = await getMetadata(await tokenURI(i, kit));
      nfts.push({ ...metadata, id: i });
    }
    setTokens(nfts);
  }, [kit, kit.web3]);

  useLayoutEffect(() => {
    if (!kit.web3) return;
    loadAllTokens();
  }, [kit.web3]);

  return (
    <Layout>
      {tokens.length > 0 ? (
        <>
          <VStack spacing={10}>
            <Heading>All NFTs</Heading>

            <SimpleGrid columns={{lg:4, md:2, sm:1}} justifyContent='center' spacing='20'>
              {tokens.map((t) => (
                <NFTCard token={t} key={t.image} />
              ))}
            </SimpleGrid>
          </VStack>
        </>
      ) : (
        <Heading>Loading all NFTs</Heading>
      )}
    </Layout>
  );
}

export default NFT;
